angular.module("app").config(routesConfig);

function routesConfig($stateProvider, $urlRouterProvider) {
  $urlRouterProvider.otherwise("/");

  $stateProvider.state("aboutPage", {
    url: "/about-huedata",
    component: "aboutPage",
  });

  $stateProvider.state("aboutUs", {
    url: "/about-us",
    component: "aboutUsComponent",
  });

  $stateProvider.state("login", {
    url: "/login",
    component: "loginComponent",
  });

  $stateProvider.state("sign-up", {
    url: "/sign-up",
    component: "signUpComponent",
  });

  $stateProvider.state("school-sign-up", {
    url: "/school-sign-up",
    component: "studentStaffSignUpComponent",
  });

  $stateProvider.state("single-sign-on", {
    url: "/single-sign-on/:success/:token",
    component: "studentSingleSignOnComponent",
  });

  $stateProvider.state("school-enterprise-login", {
    url: "/school-enterprise-login",
    component: "studentStaffLoginComponent",
  });

  // $stateProvider.state("schoolRegister", {
  //   url: "/school-register",
  //   component: "schoolRegisterComponent",
  // });

  $stateProvider.state("speakingEngagements", {
    url: "/huedata-speaking-engagements",
    component: "speakingEngagementsComponent",
  });

  $stateProvider.state("press", {
    url: "/huedata-press-inquiry",
    component: "pressComponent",
  });

  $stateProvider.state("members", {
    url: "/members",
    component: "membersComponent",
    onlyAdmin: true,
  });

  $stateProvider.state("verticalCoverage", {
    url: "/vertical-coverage",
    component: "verticalCoverageComponent",
    onlyAdmin: true,
  });

  // $stateProvider.state("membership", {
  //   url: "/huedata-membership",
  //   component: "membershipComponent",
  //   params: {
  //     scrollTo: false,
  //   },
  // });

  $stateProvider.state("colorEmotion", {
    url: "/color-research",
    component: "colorEmotionComponent",
  });

  // Color Naming Index v2 (React) at the original URL.
  $stateProvider.state("colorIndex", {
    url: "/color-index?:red&green&blue",
    templateUrl: "app/components/dashboards/naming-v2/naming-v2.tmpl.html",
    protected: true,
  });

  // Previous Angular page, admin only, kept as a fallback for a while.
  $stateProvider.state("colorIndexClassic", {
    url: "/color-index-classic?:red&green&blue",
    component: "colorIndexComponent",
    protected: true,
    onlyAdmin: true,
  });

  $stateProvider.state("colorPicker", {
    url: "/color-picker",
    component: "colorPickerComponent",
  });

  $stateProvider.state("colorNamingIndex", {
    url: "/color-naming-index",
    component: "colorNamingIndexComponent",
  });

  $stateProvider.state("colorIndexAccordion", {
    url: "/color-index-accordion",
    component: "colorIndexAccordionComponent",
  });

  $stateProvider.state("colorIndexTabs", {
    url: "/color-index-tabs?:color&mode",
    component: "colorIndexTabsComponent",
  });

  $stateProvider.state("colorNamingInfo", {
    url: "/color-naming-info",
    component: "colorNamingInfoComponent",
  });

  $stateProvider.state("colorIndexSearch", {
    url: "/color-index-search",
    component: "colorIndexSearchComponent",
  });

  $stateProvider.state("partners", {
    url: "/huedata-data-partners",
    component: "partnersComponent",
  });

  $stateProvider.state("reports", {
    url: "/color-reports",
    component: "reportsComponent",
    onlyAdmin: true,
    protected: true,
  });

  $stateProvider.state("reportsDetails", {
    url: "/color-reports/:id",
    component: "reportsDetailsComponent",
    onlyAdmin: true,
  });

  // $stateProvider.state("colorBlog", {
  //   url: "/color-blog",
  //   component: "colorBlogComponent",
  // });

  // The Charts list now lives inside HueExchange; old links land there.
  $stateProvider.state("infographics", {
    url: "/color-infographics",
    template: "<div></div>",
    onEnter: function () { window.location.replace("/hueex#charts"); },
  });

  $stateProvider.state("infographicsDetails", {
    url: "/color-infographics/:id",
    component: "infographicsDetailsComponent",
  });

  $stateProvider.state("internships", {
    url: "/internships",
    component: "internshipsComponent",
  });

  $stateProvider.state("customizedInfographics", {
    url: "/color-customized-infographics?tab",
    component: "customizedInfographicsComponent",
    protected: true,
    onlyAdmin: true,
  });

  $stateProvider.state("membersAnalytics", {
    url: "/huedata-members-analytics",
    component: "membersAnalyticsComponent",
    protected: true,
    onlyAdmin: true,
  });

  $stateProvider.state("publicationSchedule", {
    url: "/huedata-publication-schedule",
    component: "publicationScheduleComponent",
    onlyAdmin: true,
  });
  $stateProvider.state("goodReads", {
    url: "/color-good-reads",
    component: "goodReadsComponent",
    onlyAdmin: true,
  });

  $stateProvider.state("goodReadsDetails", {
    url: "/color-good-reads/:id",
    component: "goodReadsDetailsComponent",
    onlyAdmin: true,
  });

  $stateProvider.state("teachingMaterials", {
    url: "/color-teaching-materials",
    component: "teachingMaterialsComponent",
    onlyAdmin: true,
  });

  $stateProvider.state("teachingDetailsMaterials", {
    url: "/color-teaching-materials/:id",
    component: "teachingMaterialsDetailsComponent",
    onlyAdmin: true,
  });

  $stateProvider.state("courses", {
    url: "/color-education-courses",
    component: "coursesComponent",
    onlyAdmin: true,
  });

  $stateProvider.state("coursesDetails", {
    url: "/color-education-courses/:id",
    component: "coursesDetailsComponent",
    onlyAdmin: true,
  });

  $stateProvider.state("privacy", {
    url: "/privacy-policy",
    component: "privacyComponent",
  });

  $stateProvider.state("terms", {
    url: "/terms",
    component: "termsComponent",
  });

  $stateProvider.state("contact", {
    url: "/contact-huedata",
    component: "contactUsComponent",
  });

  $stateProvider.state("test", {
    url: "/test",
    component: "test",
  });

  $stateProvider.state("productInquiry", {
    url: "/product-inquiry",
    component: "inquiriesComponent",
  });

  $stateProvider.state("partnershipInquire", {
    url: "/partnership-inquire",
    component: "inquiriesComponent",
  });

  $stateProvider.state("educationInquire", {
    url: "/education-inquire",
    component: "inquiriesComponent",
  });

  $stateProvider.state("detailedPage", {
    url: "/detailed-page",
    component: "detailedComponent",
    protected: true,
  });

  $stateProvider.state("recover", {
    url: "/recover",
    component: "recoverComponent",
  });

  // Fashion Dashboard
  // $stateProvider.state("fashion", {
  //   url: "/fashion-color-trends",
  //   templateUrl: "app/components/dashboards/fashion/fashion.tmpl.html",
  //   protected: true,
  // });
  //
  // $stateProvider.state("contentFashion", {
  //   parent: "fashion",
  //   url: "/content",
  //   templateUrl: "app/components/dashboards/fashion/content/content.tmpl.html",
  // });

  // Auto Dashboard
  $stateProvider.state("auto", {
    url: "/auto-color-trends?:control&&id&title&hex&family",
    templateUrl: "app/components/dashboards/auto/auto.tmpl.html",
    protected: true,
  });

  // Legal Dashboard
  $stateProvider.state("legal", {
    url: "/legal-color-trademarks",
    templateUrl: "app/components/dashboards/legal/legal.tmpl.html",
    protected: true,
    onlyAdmin: true,
  });

  $stateProvider.state("ownerLegal", {
    parent: "legal",
    url: "/owner",
    templateUrl: "app/components/dashboards/legal/owner/owner.tmpl.html",
  });

  $stateProvider.state("yearLegal", {
    parent: "legal",
    url: "/year",
    templateUrl: "app/components/dashboards/legal/year/year.tmpl.html",
  });

  $stateProvider.state("colorLegal", {
    parent: "legal",
    url: "/color",
    templateUrl: "app/components/dashboards/legal/color/color.tmpl.html",
  });

  $stateProvider.state("productLegal", {
    parent: "legal",
    url: "/product",
    templateUrl: "app/components/dashboards/legal/product/product.tmpl.html",
  });

  // Brand Dashboard: Brand Colors v2 (React) at the original URL.
  $stateProvider.state("branding", {
    url: "/branding-colors?:control&&id",
    templateUrl: "app/components/dashboards/branding-v2/branding-v2.tmpl.html",
    protected: true,
  });

  // The review URL used during the redesign keeps working.
  $stateProvider.state("brandingV2", {
    url: "/brand-colors-v2?:control&&id",
    templateUrl: "app/components/dashboards/branding-v2/branding-v2.tmpl.html",
    protected: true,
  });

  // Previous Angular page, admin only, kept as a fallback for a while.
  $stateProvider.state("brandingClassic", {
    url: "/branding-colors-classic",
    templateUrl: "app/components/dashboards/branding/branding.tmpl.html",
    protected: true,
    onlyAdmin: true,
  });

  $stateProvider.state("thank-you", {
    url: "/thank-you",
    params: {
      'free' : false
    },
    component: "thankYouComponent",
  });

  $stateProvider.state("password-recover", {
    url: "/password-recover/:token",
    component: "passwordRecoverComponent",
  });

  $stateProvider.state("set-password", {
    url: "/set-password/:token",
    component: "setPasswordComponent",
  });

  $stateProvider.state("staffLogin", {
    url: "/staff-login",
    component: "staffLoginComponent",
  });
  $stateProvider.state("profile", {
    url: "/profile",
    component: "profileComponent",
    protected: true,
  });
  $stateProvider.state("cart-page", {
    url: "/cart?:wayBack",
    component: "cartPageComponent",
  });
  $stateProvider.state("cart-checkout", {
    url: "/cart-checkout",
    component: "cartCheckoutMethodsComponent",
  });
  $stateProvider.state("download-excerpt", {
    url: "/download-excerpt/:type/:id",
    component: "downloadExcerptPageComponent",
  });
  $stateProvider.state("password-recover-cart", {
    url: "/password-recover-cart",
    component: "passwordRecoverCartComponent",
  });
  $stateProvider.state("cart-thank", {
    url: "/cart-thank",
    component: "cartThankComponent",
  });
  $stateProvider.state("landing-page", {
    url: "/",
    component: "landingPageComponent",
  });
  // Every saved board, all dashboards, from the account link in the HueBench bar.
  $stateProvider.state("my-boards", {
    url: "/my-boards",
    templateUrl: "app/components/my-boards/my-boards.tmpl.html",
    protected: true,
  });
  $stateProvider.state("my-purchases", {
    url: "/my-purchases",
    component: "myPurchasesComponent",
    protected: true,
  });
  $stateProvider.state("unsubscribe", {
    url: "/unsubscribe?:token",
    component: "unsubscribeComponent",
  });
  $stateProvider.state("order-email", {
    url: "/order-email?:token",
    component: "orderEmailComponent",
  });
  // $stateProvider.state("home", {
  //   url: "/home-colors",
  //   component: "homeColorsComponent",
  //   protected: true,
  // });

  // Pharma Dashboard: Pharma Colors v2 (React) at the original URL.
  $stateProvider.state("pharma", {
    url: "/pharma-color-trends?:control&&id&title&hex",
    templateUrl: "app/components/dashboards/pharma-v2/pharma-v2.tmpl.html",
    protected: true,
  });

  // Previous Angular page, admin only, kept as a fallback for a while.
  $stateProvider.state("pharma-classic", {
    url: "/pharma-color-trends-classic?:control&&id&title&hex",
    templateUrl: "app/components/dashboards/pharma/pharma.tmpl.html",
    protected: true,
    onlyAdmin: true,
  });

  // Game Dashboard: Video Game Colors v2 (React) at the original URL.
  $stateProvider.state("vr-games", {
    url: "/video-games-colors?:control&&id&title&hex&name",
    templateUrl: "app/components/dashboards/games-v2/games-v2.tmpl.html",
    protected: true,
  });

  // Previous Angular page, admin only, kept as a fallback for a while.
  $stateProvider.state("vr-games-classic", {
    url: "/video-games-colors-classic?:control&&id&title&hex&name",
    templateUrl: "app/components/dashboards/games/game.tmpl.html",
    protected: true,
    onlyAdmin: true,
  });

  // Fragrance Dashboard: Perfume Colors v2 (React) at the original URL.
  $stateProvider.state("fragrance", {
    url: "/fragrance-colors?:control&&id&title&hex&name",
    templateUrl: "app/components/dashboards/fragrance-v2/fragrance-v2.tmpl.html",
    protected: true,
  });

  // Previous Angular page, admin only, kept as a fallback for a while.
  $stateProvider.state("fragrance-classic", {
    url: "/fragrance-colors-classic?:control&&id&title&hex&name",
    templateUrl: "app/components/dashboards/fragrance/fragrance.tmpl.html",
    protected: true,
    onlyAdmin: true,
  });

  // Legal Dashboard: Color Trademarks v2 (React) at the original URL.
  $stateProvider.state("legal-trends", {
    url: "/legal-color-trends?:control&&id&title&hex&family",
    templateUrl: "app/components/dashboards/legal-v2/legal-v2.tmpl.html",
    protected: true,
  });

  // Previous Angular page, admin only, kept as a fallback for a while.
  $stateProvider.state("legal-trends-classic", {
    url: "/legal-color-trends-classic?:control&&id&title&hex&family",
    templateUrl: "app/components/dashboards/legal-trends/legal.tmp.html",
    protected: true,
    onlyAdmin: true,
  });

  // Home Dashboard: Interior Colors v2 (React) at the original URL.
  $stateProvider.state("home", {
    url: "/home-color-trends?:control&&id&title&hex&family",
    templateUrl: "app/components/dashboards/home-v2/home-v2.tmpl.html",
    protected: true,
  });

  // Previous Angular page, admin only, kept as a fallback for a while.
  $stateProvider.state("home-classic", {
    url: "/home-color-trends-classic?:control&&id&title&hex&family",
    templateUrl: "app/components/dashboards/home-trends/home.tmp.html",
    protected: true,
    onlyAdmin: true,
  });

  // Art Dashboard: Art Colors v2 (React) at the original URL.
  $stateProvider.state("art", {
    url: "/art-color-trends?:control&&id&title&name&hex",
    templateUrl: "app/components/dashboards/art-v2/art-v2.tmpl.html",
    protected: true,
  });

  // Previous Angular page, admin only, kept as a fallback for a while.
  $stateProvider.state("art-classic", {
    url: "/art-color-trends-classic?:control&&id&title&name&hex",
    templateUrl: "app/components/dashboards/art/art.tmp.html",
    protected: true,
    onlyAdmin: true,
  });

  // Color Geography (React). Open to everyone: the API serves the teaser
  // (palettes, flags, region climate) to all and the images and field palettes
  // to paid plans. Replaces the static /geography page, which now redirects here.
  $stateProvider.state("color-geography", {
    url: "/color-geography?country&region",
    templateUrl: "app/components/dashboards/geography-v2/geography-v2.tmpl.html",
  });

  // Book Colors (React): book cover colors by genre, year, market and price.
  $stateProvider.state("book-colors", {
    url: "/book-colors?:mode&control",
    templateUrl: "app/components/dashboards/books-v2/books-v2.tmpl.html",
    protected: true,
  });

  // Nature Dashboard: Nature Colors v2 (React) at the original URL.
  $stateProvider.state("nature", {
    url: "/nature-color-trends?:mode&control&&id&title&hex&hex1",
    templateUrl: "app/components/dashboards/nature-v2/nature-v2.tmpl.html",
    protected: true,
  });

  // Previous Angular page, admin only, kept as a fallback for a while.
  $stateProvider.state("nature-classic", {
    url: "/nature-color-trends-classic?:mode&control&&id&title&hex&hex1",
    templateUrl: "app/components/dashboards/nature/nature.tmp.html",
    protected: true,
    onlyAdmin: true,
  });

  // Social Dashboard: The Global Color Pulse v2 (React) at the original URL.
  $stateProvider.state("globalColor", {
    url: "/global-color-pulse",
    templateUrl: "app/components/dashboards/social-v2/social-v2.tmpl.html",
    protected: true,
  });

  // The review URL used during the redesign keeps working.
  $stateProvider.state("socialV2", {
    url: "/colour-pulse-v2",
    templateUrl: "app/components/dashboards/social-v2/social-v2.tmpl.html",
    protected: true,
  });

  // Previous Angular page, admin only, kept as a fallback for a while.
  $stateProvider.state("globalColorClassic", {
    url: "/global-color-pulse-classic",
    templateUrl: "app/components/global-colors-tracker/globalColorsTracker.tmpl.html",
    protected: true,
    onlyAdmin: true,
  });

  // Sport Colors v2 (React) at the original URL: team colors, jerseys and results.
  $stateProvider.state("sport", {
    url: "/sport-color-trends?:control&&id&title&hex",
    templateUrl: "app/components/dashboards/sport-v2/sport-v2.tmpl.html",
    protected: true,
  });

  // New Fashion Dashboard
  $stateProvider.state("fashion", {
    url: "/fashion-color-trends?:control&&id&name&hex",
    templateUrl: "app/components/dashboards/fashion-trends/fashion.tmpl.html",
    protected: true,
  });

  // pricing
  $stateProvider.state("pricing", {
    url: "/pricing",
    component: "pricingComponent",
  });

  // Color Research Index v2 (React) at the original URL.
  $stateProvider.state("colorResearchIndex", {
    url: "/color-research-index",
    templateUrl: "app/components/dashboards/research-v2/research-v2.tmpl.html",
    protected: true,
  });

  // Previous Angular page, admin only, kept as a fallback for a while.
  $stateProvider.state("colorResearchIndexClassic", {
    url: "/color-research-index-classic",
    templateUrl: "app/components/color-research/color-research.tmpl.html",
    protected: true,
    onlyAdmin: true,
  });

  // color unicorn index
  $stateProvider.state("colorUnicornIndex", {
    url: "/color-unicorn-index",
    templateUrl: "app/components/color-unicorn/color-unicorn.tmpl.html",
    protected: true,
  });
  // subscription success url
  $stateProvider.state("subscriptionSuccess", {
    url: "/subscription/success",
    component: "landingPageComponent",
  });

    // subscription cancel url
    $stateProvider.state("subscriptionCancel", {
      url: "/subscription/cancel",
      component: "landingPageComponent",
    });

  // education podcats url
  $stateProvider.state("educationPodcasts", {
    url: "/education-podcasts",
    component: "educationPodcastComponent",
    protected: true,
  });

  // education podcats url
  $stateProvider.state("educationCourses", {
    url: "/education-courses",
    component: "educationCoursesComponent",
    protected: true,
  });

  $stateProvider.state("educationCoursesDetails", {
    url: "/education-courses/:id",
    component: "educationCoursesDetailsComponent",
    protected: true,
  });

  // education podcats url
  $stateProvider.state("educationTeachingMaterials", {
    url: "/education-teaching-materials",
    component: "educationTeachingComponent",
    protected: true,
  });

  $stateProvider.state("educationTeachingDetails", {
    url: "/education-teaching/:id",
    component: "educationTeachingDetailsComponent",
    protected: true,
  });

  $stateProvider.state("marketcap-companies", {
    url: "/marketcap-companies",
    component: "marketcapCompaniesComponent"
  });
}
